import React, { useEffect, useState } from "react";
import Pagination from "../../../components/Pagination/Pagination";
import { getPaymentList } from "../../../api/paymentApi";
import FullPageLoader from "../../../common/FullPageLoader";

const ResentPay = () => {
  const [payments, setPayments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  const fetchPayments = async (page = 1, searchTerm = search) => {
    try {
      setLoading(true);

      const response = await getPaymentList(page, 10, searchTerm);

      if (response.success) {
        setPayments(response.data || []);
        setCurrentPage(response.pagination?.currentPage || 1);
        setTotalItems(response.pagination?.totalItems || 0);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments(1);
  }, []);

  const handlePageChange = (page) => {
    fetchPayments(page, search);
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearch(value);
    fetchPayments(1, value);
  };

  return (
      <div className="container-fluid">
        {loading && <FullPageLoader text="Loading payments..." />}
        {/* Payment Table */}
        <div className="row clearfix mt-4">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-header">
                <div className="row w-100 align-items-center">
                  <div className="col-md-6">
                    <h4 className="card-title mb-0">Recent Payments</h4>
                  </div>

                  <div className="col-md-6 text-right">
                    <input
                      type="text"
                      className="form-control d-inline-block"
                      style={{ width: "300px" }}
                      placeholder="Search by Order Status..."
                      value={search}
                      onChange={handleSearch}
                    />
                  </div>
                </div>
              </div>

              <div className="card-body">
                {loading ? (
                  <div className="text-center py-4">Loading payments...</div>
                ) : (
                  <>
                    <div className="table-responsive">
                      <table className="table table-hover table-striped table-vcenter">
                        <thead>
                          <tr>
                            <th>Order ID</th>
                            <th>Subtotal</th>
                            <th>CGST</th>
                            <th>SGST</th>
                            <th>Total Tax</th>
                            <th>Total Amount</th>
                            <th>Status</th>
                            <th>Date</th>
                          </tr>
                        </thead>

                        <tbody>
                          {payments.length > 0 ? (
                            payments.map((item) => (
                              <tr key={item._id}>
                                <td>{item.orderId}</td>

                                <td>₹{item.subtotal}</td>

                                <td>
                                  ₹{item.tax?.cgstAmount?.toFixed(2) || "0.00"}
                                </td>

                                <td>
                                  ₹{item.tax?.sgstAmount?.toFixed(2) || "0.00"}
                                </td>

                                <td>
                                  ₹{item.tax?.totalTax?.toFixed(2) || "0.00"}
                                </td>

                                <td>
                                  <strong>
                                    ₹{item.total?.toFixed(2) || "0.00"}
                                  </strong>
                                </td>

                                <td>
                                  <span
                                    className={`badge ${
                                      item.payment?.paymentStatus === "CAPTURED"
                                        ? "badge-success"
                                        : "badge-warning"
                                    }`}
                                  >
                                    {item.payment?.paymentStatus || "Pending"}
                                  </span>
                                </td>

                                <td>
                                  {new Date(item.createdAt).toLocaleDateString(
                                    "en-IN",
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="8" className="text-center">
                                No payments found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <Pagination
                      totalItems={totalItems}
                      itemsPerPage={10}
                      currentPage={currentPage}
                      onPageChange={handlePageChange}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default ResentPay;
